module.exports = __webpack_public_path__ + "static/media/1.6b90bdd4.webp";